import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';
import BookDemo from '../../screens/BookDemo';

/**
 * Route wrapper for authenticated users. Users who are not invited (i.e. not
 * listed in the `allowedUsers` collection) are shown the Book a Demo page and
 * are blocked from accessing the rest of the app.
 *
 * Must be rendered inside an authenticated (ProtectedRoute) boundary.
 */
export default function RequireAllowedAccess() {
  const { isAllowed, isAllowedLoading } = useContext(AuthContext);

  // Still resolving whether the user is allowed — render nothing to avoid
  // briefly flashing the app to non-allowed users.
  if (isAllowedLoading) {
    return null;
  }

  if (!isAllowed) {
    return <BookDemo />;
  }

  return <Outlet />;
}
